import {
  AppBar
} from "./chunk-V2I2Z52J.js";
import {
  KeyboardShortcut,
  Menu,
  Submenu,
  isMenuItem,
  selectedTab
} from "./chunk-ZAH3JOS2.js";

// lib/dashboard.tsx
var NoDecorator = (source) => source;

// lib/layout/layout.tsx
import { BrowserView, MobileView } from "@lune/common/device";
import { LinearProgress } from "@mui/material";
import { Suspense } from "react";

// lib/layout/desktop.tsx
import styled3 from "@emotion/styled";
import { LogoutOnIdle } from "@lune/auth/logout";
import { useMoveableDivider } from "@lune/common/divider";
import { Loading } from "@lune/common/loading";
import { logDebug as logDebug2 } from "@lune/common/logger";
import { Toolbar } from "@mui/material";
import { useEffect as useEffect2, useState as useState2 } from "react";
import { Outlet } from "react-router-dom";

// lib/footer/footer.tsx
import styled from "@emotion/styled";
import { Copyright } from "@lune/common/copyright";
import { useTheme } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var FooterContainer = styled.div(() => {
  const theme = useTheme();
  return {
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: 1,
    textAlign: "center"
  };
});
var Footer = () => {
  return /* @__PURE__ */ jsx(FooterContainer, { className: "footer", children: /* @__PURE__ */ jsx(Copyright, {}) });
};

// lib/left/leftNav.tsx
import styled2 from "@emotion/styled";
import { signedFetch } from "@lune/auth/device";
import { ApiBuildNumberText } from "@lune/common/api";
import { BuildNumber } from "@lune/common/build";
import { Box, Divider, useTheme as useTheme2 } from "@mui/material";

// lib/left/leftNavSecondary.tsx
import { logoutHandlerFactory } from "@lune/auth/api";
import { logDebug } from "@lune/common/logger";
import { CheckUpdates } from "@lune/common/updates";
import { Theme } from "@lune/theme/context";
import { Logout as LogoutIcon } from "@mui/icons-material";
import {
  Backdrop,
  CircularProgress,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import hotkeys from "hotkeys-js";
import React, { useContext, useEffect, useState } from "react";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var SecondaryListItems = ({
  version,
  loginUrl,
  rootUrl,
  checkUpdates
}) => {
  const themeContext = useContext(Theme);
  const [hotkeyPressed, setHotkeyPressed] = useState(false);
  const [processing, setProcessing] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setHotkeyPressed(hotkeys.alt || hotkeys.shift);
    }, 200);
    return () => {
      clearInterval(interval);
    };
  }, []);
  useEffect(() => {
    logDebug("Capturing 'Shift+Q' to logout");
    hotkeys(`shift+q`, logoutHandlerFactory(version, loginUrl, rootUrl));
    logDebug("Capturing 'Shift+M' to toggle theme");
    hotkeys(`shift+m`, () => {
      themeContext.toggle();
    });
    return () => {
      hotkeys.unbind(`shift+q`);
      hotkeys.unbind(`shift+m`);
    };
  }, [loginUrl, rootUrl, themeContext, version]);
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsxs(
      ListItemButton,
      {
        onClick: themeContext.toggle,
        onContextMenu: themeContext.reset,
        children: [
          /* @__PURE__ */ jsx2(ListItemIcon, { children: /* @__PURE__ */ jsx2(ListItemIcon, { children: hotkeyPressed ? /* @__PURE__ */ jsx2(KeyboardShortcut, { label: "M" }) : themeContext.icon }) }),
          /* @__PURE__ */ jsx2(ListItemText, { primary: themeContext.text })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      ListItemButton,
      {
        onClick: logoutHandlerFactory(version, loginUrl, rootUrl, () => {
          setProcessing(true);
        }),
        children: [
          /* @__PURE__ */ jsx2(ListItemIcon, { children: hotkeyPressed ? /* @__PURE__ */ jsx2(KeyboardShortcut, { label: "Q" }) : /* @__PURE__ */ jsx2(LogoutIcon, {}) }),
          /* @__PURE__ */ jsx2(ListItemText, { primary: "Logout" })
        ]
      }
    ),
    /* @__PURE__ */ jsx2(
      CheckUpdates,
      {
        rootUrl,
        checkEveryMs: checkUpdates.everyMs,
        disabled: checkUpdates.disabled
      }
    ),
    /* @__PURE__ */ jsx2(Backdrop, { open: processing, children: /* @__PURE__ */ jsx2(CircularProgress, { color: "inherit" }) })
  ] });
};

// lib/left/leftNav.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var NavContainer = styled2.nav(
  ({ theme, width }) => `
  width: ${width}px;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-right: 1px solid ${theme.palette.divider};
`
);
var BuildContainer = styled2.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
var ContentContainer = styled2.div`
  flex: 1;
  overflow: auto;
`;
var LeftNav = ({
  version,
  loginUrl,
  rootUrl,
  checkUpdates,
  items,
  onNavigate,
  location,
  width,
  apiVersionFetcher = signedFetch
}) => {
  const theme = useTheme2();
  const controls = /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx3(Divider, {}),
    /* @__PURE__ */ jsx3(Box, { children: /* @__PURE__ */ jsx3(
      SecondaryListItems,
      {
        version,
        loginUrl,
        rootUrl,
        checkUpdates
      }
    ) })
  ] });
  return /* @__PURE__ */ jsx3(Fragment, { children: /* @__PURE__ */ jsxs2(NavContainer, { className: "leftNav", theme, width, children: [
    /* @__PURE__ */ jsxs2(ContentContainer, { children: [
      /* @__PURE__ */ jsx3(
        Menu,
        {
          items,
          onNavigate,
          location
        }
      ),
      controls
    ] }),
    /* @__PURE__ */ jsxs2(BuildContainer, { children: [
      /* @__PURE__ */ jsx3(BuildNumber, {}),
      /* @__PURE__ */ jsx3(
        ApiBuildNumberText,
        {
          version,
          rootUrl,
          fetcher: apiVersionFetcher
        }
      )
    ] })
  ] }) });
};

// lib/layout/desktop.tsx
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var Screen = styled3.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;
var Body = styled3.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  overflow: hidden;
`;
var Canvas = styled3.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
`;
var Content = styled3.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
`;
var DEFAULT_LEFT_NAV_SIZE = 240;
var STORAGE_KEY = "leftNavWidth";
var Desktop = ({
  logo,
  name,
  version,
  versionLogo,
  navigation,
  buttons,
  loginUrl,
  rootUrl,
  checkUpdates = {},
  logoffOnIdle = {},
  decorator = NoDecorator,
  onNavigate,
  onTick,
  onSearch,
  location,
  enableSearch,
  appbarContent,
  leftNavSize = DEFAULT_LEFT_NAV_SIZE
}) => {
  const [tick, setTick] = useState2(Date.now());
  const [searchTerm, setSearchTerm] = useState2();
  const [leftWidth, divider] = useMoveableDivider({
    storageKey: STORAGE_KEY,
    defaultSize: leftNavSize,
    minSize: 100,
    maxSize: 600
  });
  const context = {
    search: searchTerm,
    setSearch: setSearchTerm,
    clearSearch: () => setSearchTerm(""),
    clockTick: tick
  };
  useEffect2(() => {
    if (onTick) {
      onTick(tick);
    }
  }, [tick, onTick]);
  useEffect2(() => {
    if (onSearch) {
      onSearch(searchTerm);
    }
  }, [searchTerm, onSearch]);
  logDebug2("Rendering desktop version");
  return /* @__PURE__ */ jsxs3(Fragment2, { children: [
    /* @__PURE__ */ jsx4(
      AppBar,
      {
        version,
        logo,
        versionLogo,
        name,
        content: appbarContent,
        setTick,
        searchTerm,
        setSearchTerm,
        buttons,
        loginUrl,
        rootUrl,
        enableSearch
      }
    ),
    /* @__PURE__ */ jsxs3(Screen, { children: [
      /* @__PURE__ */ jsx4(Toolbar, {}),
      /* @__PURE__ */ jsxs3(Body, { children: [
        /* @__PURE__ */ jsx4(
          LeftNav,
          {
            version,
            loginUrl,
            rootUrl,
            checkUpdates,
            items: navigation,
            onNavigate,
            location,
            width: leftWidth
          }
        ),
        divider,
        /* @__PURE__ */ jsxs3(Canvas, { children: [
          /* @__PURE__ */ jsx4(Content, { children: decorator(
            /* @__PURE__ */ jsx4(Loading, { children: /* @__PURE__ */ jsx4(Outlet, { context }) })
          ) }),
          /* @__PURE__ */ jsx4(Footer, {})
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx4(
      LogoutOnIdle,
      {
        version,
        timeoutMs: logoffOnIdle.afterMs,
        loginUrl,
        rootUrl,
        disabled: logoffOnIdle.disabled
      }
    )
  ] });
};

// lib/layout/mobile.tsx
import styled5 from "@emotion/styled";
import { LogoutOnIdle as LogoutOnIdle2 } from "@lune/auth/logout";
import { Loading as Loading2 } from "@lune/common/loading";
import { logDebug as logDebug3 } from "@lune/common/logger";
import { CheckUpdates as CheckUpdates2 } from "@lune/common/updates";
import { Toolbar as Toolbar2 } from "@mui/material";
import { useEffect as useEffect4, useState as useState4 } from "react";
import { Outlet as Outlet2 } from "react-router-dom";
import PullToRefreshHandler from "react-simple-pull-to-refresh";

// lib/bottom/bottomNav.tsx
import styled4 from "@emotion/styled";
import {
  ArrowBackRounded as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon
} from "@mui/icons-material";
import { Box as Box2, Button, Typography } from "@mui/material";
import { useEffect as useEffect3, useState as useState3 } from "react";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var MAX_ITEMS = 5;
var NavButton = styled4(Button)`
  flex: 0;
  color: gray;
  min-width: 32px;
`;
var MenuButton = styled4(Button)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
var ButtonText = styled4(Typography)`
  max-width: 78px;
  max-height: 24px;
  overflow: hidden;
`;
var BottomNav = ({
  items,
  onNavigate,
  location = document.location
}) => {
  const [first, setFirst] = useState3(0);
  const [value, setValue] = useState3(selectedTab(items, location));
  useEffect3(() => {
    const tab = selectedTab(items, location);
    setValue(tab);
    setFirst(
      Math.max(
        0,
        Math.min(
          items.length - MAX_ITEMS,
          tab < MAX_ITEMS ? 0 : tab - MAX_ITEMS + 1
        )
      )
    );
  }, [items, location]);
  return /* @__PURE__ */ jsxs4(
    Box2,
    {
      sx: {
        display: "flex",
        height: 56,
        borderTop: "1px solid rgba(0,0,0,0.1)"
      },
      children: [
        items.length > MAX_ITEMS && /* @__PURE__ */ jsx5(
          NavButton,
          {
            disabled: first === 0,
            onClick: () => {
              setFirst((first2) => first2 - 1);
            },
            children: /* @__PURE__ */ jsx5(ArrowBackIcon, {})
          }
        ),
        items.filter(isMenuItem).slice(first, first + MAX_ITEMS).map((item, index) => /* @__PURE__ */ jsxs4(
          MenuButton,
          {
            sx: first + index === value ? { color: "dodgerblue" } : { color: "gray" },
            onClick: () => {
              setValue(first + index);
              void onNavigate(item.target);
            },
            children: [
              item.icon,
              /* @__PURE__ */ jsx5(ButtonText, { variant: "caption", children: item.text })
            ]
          },
          item.id
        )),
        items.length > MAX_ITEMS && /* @__PURE__ */ jsx5(
          NavButton,
          {
            disabled: first + MAX_ITEMS >= items.length,
            onClick: () => {
              setFirst((first2) => first2 + 1);
            },
            children: /* @__PURE__ */ jsx5(ArrowForwardIcon, {})
          }
        )
      ]
    }
  );
};

// lib/layout/mobile.tsx
import { Fragment as Fragment3, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var Screen2 = styled5.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
`;
var PullToRefresh = styled5(PullToRefreshHandler)`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  & .ptr__children {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
  }
`;
var Mobile = ({
  logo,
  name,
  version,
  versionLogo,
  navigation,
  buttons,
  loginUrl,
  rootUrl,
  checkUpdates = {},
  logoffOnIdle = {},
  decorator = NoDecorator,
  onNavigate,
  onTick,
  onSearch,
  location,
  enableSearch,
  appbarContent
}) => {
  const [tick, setTick] = useState4(Date.now());
  const [searchTerm, setSearchTerm] = useState4();
  const context = {
    search: searchTerm,
    setSearch: setSearchTerm,
    clearSearch: () => setSearchTerm(""),
    clockTick: tick
  };
  useEffect4(() => {
    if (onTick) {
      onTick(tick);
    }
  }, [tick, onTick]);
  useEffect4(() => {
    if (onSearch) {
      onSearch(searchTerm);
    }
  }, [searchTerm, onSearch]);
  logDebug3("Rendering mobile version");
  const handleRefresh = async () => {
    setTick(Date.now());
  };
  return /* @__PURE__ */ jsxs5(Fragment3, { children: [
    /* @__PURE__ */ jsx6(
      AppBar,
      {
        version,
        logo,
        versionLogo,
        name,
        content: appbarContent,
        setTick,
        searchTerm,
        setSearchTerm,
        buttons,
        loginUrl,
        rootUrl,
        enableSearch
      }
    ),
    /* @__PURE__ */ jsxs5(Screen2, { children: [
      /* @__PURE__ */ jsx6(Toolbar2, {}),
      /* @__PURE__ */ jsx6(
        CheckUpdates2,
        {
          rootUrl,
          disabled: checkUpdates?.disabled,
          checkEveryMs: checkUpdates?.everyMs
        }
      ),
      /* @__PURE__ */ jsx6(PullToRefresh, { onRefresh: handleRefresh, children: /* @__PURE__ */ jsxs5(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            flex: 1
          },
          children: [
            decorator(
              /* @__PURE__ */ jsx6(Loading2, { children: /* @__PURE__ */ jsx6(Outlet2, { context }) })
            ),
            /* @__PURE__ */ jsx6(Footer, {})
          ]
        }
      ) }),
      /* @__PURE__ */ jsx6(
        BottomNav,
        {
          items: navigation,
          onNavigate,
          location
        }
      )
    ] }),
    /* @__PURE__ */ jsx6(
      LogoutOnIdle2,
      {
        version,
        timeoutMs: logoffOnIdle.afterMs,
        loginUrl,
        rootUrl,
        disabled: logoffOnIdle.disabled
      }
    )
  ] });
};

// lib/layout/layout.tsx
import { Fragment as Fragment4, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var Dashboard = (props) => {
  return /* @__PURE__ */ jsx7(Suspense, { fallback: /* @__PURE__ */ jsx7(LinearProgress, {}), children: /* @__PURE__ */ jsxs6(Fragment4, { children: [
    /* @__PURE__ */ jsx7(BrowserView, { children: /* @__PURE__ */ jsx7(Desktop, { ...props }) }),
    /* @__PURE__ */ jsx7(MobileView, { children: /* @__PURE__ */ jsx7(Mobile, { ...props }) })
  ] }) });
};
export {
  AppBar,
  Dashboard,
  Menu,
  Menu as MenuItems,
  NoDecorator,
  Submenu,
  selectedTab
};
